import { Box, CircularProgress } from "@mui/material";
import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../../components/Header";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import DailyConsumptionForm from "../../../components/FormDaily";
import { useTranslation } from "react-i18next";

const UpdateDailyConsumption = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const { id } = useParams();
  const navigate = useNavigate();
  const [consumption, setConsumption] = useState(null);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const apiUrl = "https://oven-backend.onrender.com";

  useEffect(() => {
    const fetchConsumption = async () => {
      try {
        const response = await axios.get(`${apiUrl}/dailyConsumption/${id}`);
        setConsumption(response.data);
      } catch (error) {
        console.error("❌ خطأ في جلب بيانات الاستهلاك اليومي:", error);
        setError(t("error_fetching_consumption"));
      } finally {
        setLoading(false);
      }
    };
    fetchConsumption();
  }, [id, t]);

  const handleFormSubmit = async (values) => {
    try {
      const formattedValues = {
        ...values,
        consumedAmount: Number(values.consumedAmount),
        consumptionDate: new Date(values.consumptionDate).toISOString(),
      };
      console.log("✅ إرسال طلب التحديث مع:", formattedValues);
      const response = await axios.patch(`${apiUrl}/dailyConsumption/${id}`, formattedValues);
      console.log("✅ تم تحديث الاستهلاك اليومي بنجاح:", response.data);
      setOpen(true);
      setTimeout(() => {
        navigate("/dailyConsumption");
      }, 1000);
    } catch (error) {
      console.error("❌ خطأ في تحديث الاستهلاك اليومي:", error.response?.data || error);
      setError(t("error_updating_consumption"));
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!consumption) {
    return <Alert severity="error">{t("consumption_not_found")}</Alert>;
  }

  const initialValues = {
    item: consumption.item?._id || "",
    recordedBy: consumption.recordedBy?._id || "",
    consumedAmount: consumption.consumedAmount?.toString() || "",
    consumptionDate: consumption.consumptionDate?.split("T")[0] || new Date().toISOString().split("T")[0],
    notes: consumption.notes || "",
  };
  console.log("✅ القيم الأولية الممررة إلى DailyConsumptionForm:", initialValues);

  return (
    <Box m="20px" sx={{ direction: isRTL ? "rtl" : "ltr" }}>
      <Header
        title={t("update_daily_consumption")}
        subtitle={t("update_consumption_record")}
      />
      <DailyConsumptionForm
        initialValues={initialValues}
        handleFormSubmit={handleFormSubmit}
        buttonLabel={t("update_record")}
      />
      <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}>
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%", fontFamily: isRTL ? "Cairo, sans-serif" : "Roboto, sans-serif" }}
        >
          {t("success_updated_consumption")}
        </Alert>
      </Snackbar>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
        <Alert
          onClose={() => setError(null)}
          severity="error"
          variant="filled"
          sx={{ width: "100%", fontFamily: isRTL ? "Cairo, sans-serif" : "Roboto, sans-serif" }}
        >
          {error}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UpdateDailyConsumption;